import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-linked-accounts-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="flex flex-col h-full max-h-[85vh]">
      <div class="flex items-center justify-between px-6 py-4 border-b dark:border-gray-700 flex-shrink-0">
        <h2 class="text-xl font-semibold m-0">Grupy połączonych kont ({{ data.groups.length }})</h2>
        <button mat-icon-button (click)="dialogRef.close()">
          <mat-icon svgIcon="tabler_outline:x"></mat-icon>
        </button>
      </div>

      <div class="p-6 overflow-y-auto flex-auto space-y-4">
        <div *ngFor="let group of data.groups; let i = index" class="border dark:border-gray-700 rounded-lg p-4 bg-gray-50 dark:bg-gray-800/50">
          <div class="font-medium mb-3 text-primary-600 dark:text-primary-400">Grupa #{{ i + 1 }} ({{ group.users.length }} kont)</div>
          <div class="space-y-2">
            <div *ngFor="let user of group.users" class="flex items-center space-x-3">
              <mat-icon svgIcon="heroicons_outline:user" class="text-gray-400 icon-size-4"></mat-icon>
              <div>
                <div class="text-sm font-medium">{{ user.email }}</div>
                <div class="text-xs text-gray-500 font-mono">{{ user.id }}</div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="data.groups.length === 0" class="text-center text-gray-500 py-8">
          Brak powiązanych kont.
        </div>
      </div>
    </div>
  `
})
export class LinkedAccountsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LinkedAccountsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { groups: { users: { id: string; email: string }[] }[] }
  ) {}
}
